export const isEmptyArray = (a: unknown[] | null | undefined) =>
  a && a.length === 0;
